<template>
  <div class="auth-wrapper">
    <v-snackbar v-model="error.show" color="error">
      <p class="py-0 my-0 font-weight-black">{{ error.title }}</p>
      {{ error.message }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="error.show = false">
          Fechar
        </v-btn>
      </template>
    </v-snackbar>

    <v-card v-if="logar()" class="auth-card" elevation="8">
      <div class="text-center mb-6">
        <v-avatar color="primary" size="64" class="mb-4">
          <v-icon dark size="36">mdi-shield-lock-outline</v-icon>
        </v-avatar>
        <h1 class="text-h5 font-weight-bold mb-1">Autenticação</h1>
        <p class="text-body-2 grey--text text--darken-1 mb-0">
          Forneça o código de segurança gerado no aplicativo.
        </p>
      </div>

      <v-form @submit.prevent="auth">
        <v-text-field v-model="token" label="Código de segurança" prepend-inner-icon="mdi-key" type="text" autofocus
          filled required hide-details="auto" class="mb-4" minlength="6" maxlength="6" inputmode="numeric"></v-text-field>

        <v-text-field v-model="pin" label="PIN (Opcional)" prepend-inner-icon="mdi-lock-clock" type="password" filled
          required hide-details="auto" class="mb-4" inputmode="text"></v-text-field>

        <v-btn type="submit" color="primary" x-large block :loading="loading" :disabled="!tokenValido">
          <v-icon left>mdi-login</v-icon>
          Entrar
        </v-btn>
      </v-form>

      <p class="text-center text-caption grey--text mt-6 mb-0">
        Versão {{ versao }}
      </p>
    </v-card>
  </div>
</template>

<script>
import { autenticarApiClientes } from '../../services/api';
import { checarSessao, definirPerfil } from '../../utils/utils';

export default {
  name: "Auth",
  data() {
    return {
      token: "",
      pin: "",
      loading: false,
      error: {
        show: false,
        message: "",
      },
    };
  },
  computed: {
    tokenValido() {
      return /^\d{6}$/.test(this.token);
    },
  },
  beforeMount() {
    setTimeout(this.checar, 500);
  },
  methods: {
    setError(error) {
      this.error = {
        show: true,
        title: "Ops, falhou!",
        message: (error ? error : "Falha não identificada, tente novamente."),
      };
    },
    /**
     *
     */
    logar() {
      return checarSessao();
    },
    checar() {
      const expirou = checarSessao();
      if (!expirou) {
        this.$router.push({ path: "/inicio" });
      }
    },
    /**
     *
     */
    auth() {
      if (!this.tokenValido) {
        return;
      }
      this.loading = true;
      autenticarApiClientes(this.token, this.pin)
        .then((response) => {
          definirPerfil(response.data.data.admin);
          /**
           *
           */
          if (response.data.data.token) {
            localStorage.setItem("token", response.data.data.token)
            localStorage.setItem("token_exp", new Date())
          }
          if (response.data.data.api_key) {
            localStorage.setItem('api_key', response.data.data.api_key);
          }
          if (response.data.data.asaas_id_revenda) {
            localStorage.setItem('asaas_id_revenda', response.data.data.asaas_id_revenda);
          }
          if (response.data.data.block) {
            localStorage.setItem('block', response.data.data.block);
          } else {
            localStorage.removeItem('block');
          }
          /**
           *
           */
          this.$router.push({ path: "/inicio/" });
        })
        .catch((error) => {
          this.loading = false;
          this.setError(error?.response?.data?.message);
          this.token = "";
          this.pin = "";
        });
    },
  },
};
</script>

<style scoped>
.auth-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 90vh;
  width: 100%;
  padding: 24px;
}

.auth-card {
  width: 100%;
  max-width: 420px;
  padding: 32px;
  border-radius: 16px;
}
</style>
